import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductoService } from '../../../services/producto/producto.service';
import { ElementoCarro } from '../../../../model/interface/ElementoCarro';
import { CarritoService } from '../../../services/carrito/carrito.service';
import { IProducto } from '../../../../model/interface/IProducto';
import * as _ from 'lodash';

@Component({
  selector: 'app-resultado-busqueda',
  templateUrl: './resultado-busqueda.component.html',
  styles: []
})
export class ResultadoBusquedaComponent implements OnInit {

  productosBusqueda: ElementoCarro[] = [];
  textoBuscar: string;
  ordenProductos = 'destacados';

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _productoService: ProductoService,
    private _carritoService: CarritoService,
    private router: Router
  ) {
    this._activatedRoute.params.subscribe( params => {
      this.textoBuscar = params.texto;
      this.buscarProducto();
    });
  }

  ngOnInit() {
  }


  buscarProducto () {

    // this.textoBuscar = _.trim(this.textoBuscar);

    let texto =  this.textoBuscar.replace(new RegExp('span', 'ig'), '');
    texto = _.trim(texto);

    if (texto) {

      const objetoBucar: any[] = [{'name': texto}];
      const parametros = {search: JSON.stringify(objetoBucar)};

      this._productoService.getPublicados(parametros)
        .subscribe( data => {
          this.productosBusqueda = this._carritoService.enriquecerProductos(data);
        });
    } else {
      this.productosBusqueda = [];
    }

    this._carritoService.carroProductos
      .subscribe( data => {

        this.productosBusqueda = this._carritoService.actualizarProductos(this.productosBusqueda);
      });
  }

  ordenarProductos(model?: string) {

    if (model) {
      this.ordenProductos = model;
    }

    switch (this.ordenProductos) {
      case 'destacados': {
        this.productosBusqueda = _.orderBy(this.productosBusqueda, (o: ElementoCarro) => {
          return o.producto.seleccionSF;
        });
        break;
      }
      case 'masNuevos': {
        this.productosBusqueda = _.orderBy(this.productosBusqueda, (o: ElementoCarro) => {
          return o.producto.fecCreacion;
        }, 'desc');
        break;
      }
      case 'alfabeticamente': {
        this.productosBusqueda = _.orderBy(this.productosBusqueda, (o: ElementoCarro) => {
          return o.producto.nombre;
        });
        break;
      }
    }

  }

  agregarProductoCotizacion(producto: ElementoCarro) {
    const clon = _.clone(producto);
    this._carritoService.agregarProducto(clon);
  }

  quitarProductoCotizacion(producto: ElementoCarro) {
    const clon = _.clone(producto);
    this._carritoService.quitarProducto(clon);
  }

  linkAlProducto(route: any) {
    this.router.navigate(route);
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/shared/resultado-busqueda/resultado-busqueda.component.ts